import { VField } from '../../components/Fields'

export default function FormCambioPassword() {
  return (
    <div className="row">
      <div className="col-12">
        <VField type='password' name="old_password" label="Vecchia password" required />
      </div>
      <div className="col-6">
        <VField type='password' name="password" label="Nuova password" required />
      </div>
      <div className="col-6">
        <VField type='password' name="confirm_password" label="Conferma password" required />
      </div>
    </div>
  )
}
